import { useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import { useDates } from "../../../dates/DatesContext";
import useSelectedMetrics from "../../../components/custom/merchandise/hooks/useSelectedMetrics";
import MultiMetricChart from "../../../components/custom/merchandise/MultiMetricChart";
import Loading from "../../../components/core/blocks/Loading";
import DetailedMetric from "../../../components/core/blocks/DetailedMetric";
import { useDSPLineItemDatasetsQuery } from "../hooks/useDSPLineItemDatasetsQuery";
import getMetricSpec from "../../merchandising/utils/metrics";

const LineItemExpander = ({ row }) => {
  const { group } = useDates();

  const { line_item_id: lineItemId, name } = row.original ?? {};

  const lineItemIdFilter = { id: "line_item_id", value: { op: "eq", value: lineItemId } };

  const { data: datasetsResult, isLoading: isLineItemDataLoading } = useDSPLineItemDatasetsQuery(
    "line_item_id",
    false,
    [lineItemIdFilter],
  );

  const { data: datasetsTimeSeriesResult } = useDSPLineItemDatasetsQuery(`line_item_id,start_date`, false, [
    lineItemIdFilter,
  ]);

  const data = useMemo(() => {
    const timeSeriesRows = datasetsTimeSeriesResult?.data ?? [];
    return {
      date: timeSeriesRows,
      total: datasetsResult?.data?.[0] ?? {},
      metadata: {},
      isLoading: isLineItemDataLoading,
    };
  }, [datasetsResult, datasetsTimeSeriesResult, isLineItemDataLoading]);

  const { selectedMetrics, toggleMetric } = useSelectedMetrics(
    ["dsp_sales", "dsp_cost", "dsp_units"],
    "dspLineItemExpander",
  );

  const metrics = useMemo(
    () => [
      getMetricSpec("dsp_sales"),
      getMetricSpec("dsp_total_sales"),
      getMetricSpec("dsp_impressions"),
      getMetricSpec("dsp_clicks"),
      getMetricSpec("dsp_cost"),
      getMetricSpec("dsp_total_purchases"),
    ],
    [],
  );

  const handleLegendChange = (e) => {
    const id = e.target?.options?.custom?.id;
    if (id) toggleMetric(id);
    return false;
  };

  if (isLineItemDataLoading) {
    return <Loading height={"300px"} fullPage={false} />;
  }

  return (
    <div className="bg-white">
      <Row className="pt-3">
        <Col xs={12} md={6} className="pb-4 px-5">
          <h3
            style={{
              fontSize: 22,
            }}
          >
            {name}
          </h3>
        </Col>
        <Col xs={12}>
          <MultiMetricChart
            metrics={metrics}
            selectedMetrics={selectedMetrics}
            data={data?.date ?? []}
            group={group}
            handleLegendChange={handleLegendChange}
            showAnnotations={false}
          />
        </Col>
        <Col xs={12}>
          <Row className="pt-4">
            {metrics?.map((m, i) => {
              return (
                <Col xs={12} md={6} lg={2} key={m.id} className={`mb-4 ${i % 2 === 0 ? "ps-2" : "pe-2"}`}>
                  <div className="">
                    <div>
                      <DetailedMetric center metric={m} data={data?.total} showTarget={false} />
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default LineItemExpander;
